<template lang="pug">
f7-page#tokushoho
  background
    section
      h2 特定商取引法に基づく表記

    section
      h3 アプリ名
      p スポともダンス

    section
      h3 事業者名(会社名)
      p 株式会社 だんきち

    section
      h3 代表者名
      p 代表取締役 与島 大樹

    section
      h3 所在地
      p 〒566-0024
      p 大阪府摂津市正雀本町１丁目３８−１０−２０２

    section
      h3 お問い合わせ
      p
        a(class="external" href="mailto:spotomo_support@dank-1.com") spotomo_support@dank-1.com
      p 06-6836-7044

    section
      h3 役務の対価
      p 購入手続きの際に画面に表示されます。※消費税込

    section
      h3 役務の対価以外でお客様に発生する金銭
      p サービスの特性上、送料は発生いたしません。
      p 以下の料金はお客様のご負担となります。
      p ・当アプリ内におけるインターネット接続料金、通信料金
      p ・トレーニングにおけるスタジオなどのレンタル料金
      p ・トレーニングに必要となる各種器具の購入料金
      p ・端末を固定する器具などの購入料金

    section
      h3 お支払い方法
      p 以下のいずれかのお支払方法をご利用いただけます。
      p ・各種クレジットカード
      p ・コンビニ決済
      p ・その他、購入にかかる決済を代行する会社が提供するお支払方法

    section
      h3 お支払いの期限
      p 当アプリによるサービスの提供前に、指定された各種お支払い方法による決済をしていただき、以後、毎月25日までに翌月分の利用料をお支払いいただきます。

    section
      h3 レッスンの利用が可能となる時期
      p AppStore・Google Playで提供する各アプリを通じてサポートセンターと連絡を取り、申し込みの意思を伝えた上で、指定された各種お支払い方法で決済していただきますと、レッスンが開始できるようにないrます。但し、LIVEレッスン（リアルタイムレッスン）の日程は各講師との調整を要します。

    section
      h3 動作確認済み環境
      p 以下の端末・OSで動作確認しております。
      p 動作確認環境以外でご利用された場合、正常に表示できない場合がございます。また、現在動作確認環境に記載のある端末・OSであっても、今後のバージョンアップなどに伴い、正常に動作しなくなる場合もございますのであらかじめご了承ください。
      p ・端末：iPhone 12 / iPhone XR / iPad Pro (9.7inch)
      p ・OS：iOS 15 / iPadOS 15
      p ※上記環境でご利用の場合でもお客様の環境により正常に動作しない場合があります。

    section
      h3 途中解約・キャンセル
      p 途中解約された場合、いかなる理由でも返金はできませんので、ご了承ください。

    section
      h3 特別条件
      p 定期課金方式の注意事項
      p 月額料金プランの課金は、解約手続きまたは料金プランの変更を行わない限り、自動的に継続されます。解約の際は、電話またはメールで当社までお知らせください。当月24日までに解約手続きをとられた場合は、当月末日で解約するものとし、翌月分の月額料金は発生しません。当月25日以降に解約手続きをとられた場合は、翌月末日で解約するものとし、翌月分の月額料金が発生します。
      p 初月無料キャンペーンをご利用の場合、無料期間及び無料期間終了後から起算して6か月間は、いかなる理由でも途中解約（退会）はできません。契約期間満了後に退会の申請が可能となります。やむを得ず当該期間中に退会を希望する場合は、契約残期間に応じた月額レッスン料の残額を違約金として一括で支払うものとします。

    section
      h3 サポート対応時間
      p スポともダンス営業日の10:00 - 17:00
</template>

<style lang="scss" scoped>
@import '@/styles/public-common.scss';

#tokushoho section:last-child {
  margin-bottom: 56px;
}
</style>

<script>
import PageTitle from '@/components/mixins/PageTitle'

export default {
  mixins: [PageTitle],
  title: '特定商取引法に基づく表記',
}
</script>
